import get from 'lodash/get';

export default {
    computed: {
        compensationMethods() {
            return get(this, 'campaign.compensation', []);
        },
        compensationDescription() {
            if (this.isCustomCompensationDescription) {
                return this.customCompensationDescription;
            }

            const chunks = {
                money: ' a fixed amount',
                affiliate: 'by commission',
                product: 'with products'
            };

            return `You will be paid ${this.compensationMethods.map((type) => chunks[type]).join(', ')}.`.replace(
                /, ([^,]*)$/,
                ', and $1'
            );
        },
        customCompensationDescription() {
            const desc = get(this, 'campaign.customization.compensation_step_overview');

            if (!!desc) {
                return desc;
            }

            return null;
        },
        customPaymentDescription() {
            const desc = get(this, 'campaign.customization.compensation_payment_overview');

            if (!!desc) {
                return desc;
            }

            return 'Please input your desired price.';
        },
        isCustomCompensationDescription() {
            return !!this.customCompensationDescription;
        }
    }
};
